import dayjs from 'dayjs';

export const checkIfEnoughData = (data: Record<string, unknown>[]) => {
  const result = data.reduce((numberOfInvalidDataPoints: number, dataPoint: Record<string, unknown>) => {
    if (dataPoint.soldAvg === null) {
      numberOfInvalidDataPoints = numberOfInvalidDataPoints + 1;
    }
    return numberOfInvalidDataPoints;
  }, 0);
  return result <= 11;
};

export const getPercentageChange = (currentValue = 0, valueInTime = 0) => {
  const delta = currentValue - valueInTime;
  const value = Math.round((delta / currentValue) * 100);

  if (typeof value === 'number' && isFinite(value)) {
    return value.toFixed(0);
  } else {
    return '-';
  }
};

export const getDifferenceInStringifiedStats = (value: string | number, comparison: string | number) => {
  return (Number(value) - Number(comparison)).toFixed(0);
};

export const getColourOfStat = (stat: string | number) => {
  const value = Number(stat);
  if (value === 0) {
    return;
  } else {
    return value > 0 ? '#84a338' : '#c6483a';
  }
};

export const getIntervalPercentageChanges = (chartData: Record<string, any>[]) => {
  const latestMonth = chartData[chartData.length - 1];
  const previousMonth = chartData[chartData.length - 2];
  const threeMonthsAgo = chartData[chartData.length - 4];
  const sixMonthsAgo = chartData[chartData.length - 6];
  const oneYearAgo = chartData[0];

  const oneChange = getPercentageChange(latestMonth.y, previousMonth.y);
  const threeChange = getPercentageChange(latestMonth.y, threeMonthsAgo.y);
  const sixChange = getPercentageChange(latestMonth.y, sixMonthsAgo.y);
  const yearChange = getPercentageChange(latestMonth.y, oneYearAgo.y);

  return {
    oneChange,
    threeChange,
    sixChange,
    yearChange,
  };
};

export const getDataAtPointInTime = (data: Record<string, any>[], timeAgo: number, timeIntervalAgo: 'month' | 'year') => {
  return data.filter(point => {
    const date = dayjs(point.soldAt).startOf('M').format('YYYY-MM-DD');
    if (date === dayjs(endDate).subtract(timeAgo, timeIntervalAgo).format('YYYY-MM-DD')) {
      return point;
    }
  })[0];
};

export const endDate = dayjs().startOf('M').format('YYYY-MM-DD');
export const startDate = dayjs(endDate).subtract(1, 'year').startOf('M').format('YYYY-MM-DD');
